
// src/reducers/user-reducer.js
import { mergeArray, deleteArray } from '../helpers/store'

import {
  FETCH_URL_INFO,
  FETCH_URL_INFO_REQUESTED,
  FETCH_URL_INFO_COMPLETED,
  FETCH_URL_INFO_FAILED,
  CLEAR_URL_INFO,
} from '../actions/url-info'

import {
  FETCH_GOOGLE_DRIVE_FILE,
  FETCH_GOOGLE_DRIVE_FILE_REQUESTED,
  FETCH_GOOGLE_DRIVE_FILE_COMPLETED,
  FETCH_GOOGLE_DRIVE_FILE_FAILED,
} from '../actions/google-api'

const initialState = {
}

export default function urlInfoReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_GOOGLE_DRIVE_FILE_REQUESTED:
  case FETCH_URL_INFO_REQUESTED:
    return Object.assign({}, state, {
      [action.componentId]: Object.assign({}, state[action.componentId] || {}, {
        isFetching: true,
        isFetchFailed: false,
        [action.url]: {
          item: undefined
        }
      })
    })

  case FETCH_GOOGLE_DRIVE_FILE_COMPLETED:
  case FETCH_URL_INFO_COMPLETED:
    return Object.assign({}, state, {
      [action.componentId]: Object.assign({}, state[action.componentId] || {}, {
        isFetching: false,
        isFetchFailed: false,
        [action.url]: {
          item: action.results
        }
      })
    })

  case FETCH_URL_INFO_FAILED:
  case FETCH_GOOGLE_DRIVE_FILE_FAILED:
    return Object.assign({}, state, {
      [action.componentId]: Object.assign({}, state[action.componentId] || {}, {
        isFetching: false,
        isFetchFailed: true,
        [action.url]: undefined
      })
    })

  case CLEAR_URL_INFO:
    return Object.assign({}, state, {
      [action.componentId]: undefined
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/url-info-reducer.js